import { useEffect } from "react";
import { useQuery, useSubscription, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import {
  QUERY_RACE_DATA,
  SUBSCRIBE_LAP_UPDATE,
  MUTATE_SET_LAP_ENCRYPTION_CODE,
  MUTATE_SET_LAP_ENERGY,
  MUTATE_SET_LAP_TIME,
  SUBSCRIBE_RACE_CONFIG_UPDATE,
  MUTATE_UPDATE_LAP_OFFSET,
  SUBSCRIBE_OFFSET_PREVIEWS_UPDATE,
  SUBSCRIBE_PIT_PREVIEWS_UPDATE,
  SUBSCRIBE_LAP_TABLE_UPDATE,
  SUBSCRIBE_OPTIMISATION_TRIGGER_UPDATE,
  MUTATE_SET_ATTACK_SCENARIO,
  MUTATE_SET_PIT_SCENARIO,
  MUTATE_SET_TARGET_PIT_SOC,
  MUTATE_SET_LAP_ENERGY_ENTRY,
  MUTATE_SET_LAP_COMMENT,
  MUTATE_SET_LAP_TIME_ENTRY,
} from "../queries/raceDataQueries";
import {
  setRaceData,
  updateLap,
  updateCarRaceConfig,
  updateCarOffsetPreviews,
  updateCarPitPreviews,
  updateCarOptimisationTrigger,
  updateCarLapTable,
} from "../../../state/raceDataReducer";

export function MutateSetLapEncryptionCode() {
  const [setLapEncryptionCode] = useMutation(MUTATE_SET_LAP_ENCRYPTION_CODE);
  return setLapEncryptionCode;
}

export function MutateSetLapEnergy() {
  const [setLapEnergy] = useMutation(MUTATE_SET_LAP_ENERGY);
  return setLapEnergy;
}

export function MutateSetLapEnergyEntry() {
  const [setLapEnergyEntry] = useMutation(MUTATE_SET_LAP_ENERGY_ENTRY);
  return setLapEnergyEntry;
}

export function MutateSetLapTimeEntry() {
  const [setLapTimeEntry] = useMutation(MUTATE_SET_LAP_TIME_ENTRY);
  return setLapTimeEntry;
}

export function MutateSetLapTime() {
  const [setLapTime] = useMutation(MUTATE_SET_LAP_TIME);
  return setLapTime;
}

export function MutateSetLapComment() {
  const [setLapComment] = useMutation(MUTATE_SET_LAP_COMMENT);
  return setLapComment;
}

export function MutateUpdateLapOffset() {
  const [updateLapOffset] = useMutation(MUTATE_UPDATE_LAP_OFFSET);
  return updateLapOffset;
}

export function MutateSetAttackScenario() {
  const [setAttackScenario] = useMutation(MUTATE_SET_ATTACK_SCENARIO);
  return setAttackScenario;
}

export function MutateSetPitScenario() {
  const [setPitScenario] = useMutation(MUTATE_SET_PIT_SCENARIO);
  return setPitScenario;
}

export function MutateSetTargetPitSoc() {
  const [setTargetPitSoc] = useMutation(MUTATE_SET_TARGET_PIT_SOC, {
    context: { skipRetry: true },
  });
  return setTargetPitSoc;
}

export function QueryRaceData() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_RACE_DATA);
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    if (data) {
      dispatch(setRaceData(data.getRaceData));
    }
  }, [dispatch, data, loading, error]);
}

export function SubscribeLapUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_LAP_UPDATE, {
    onData: (x) => {
      const lapUpdate = x.data.data.newLapUpdate;
      dispatch(updateLap({ carColour: lapUpdate.carColour, lap: lapUpdate }));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeRaceConfigUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_RACE_CONFIG_UPDATE, {
    onData: (x) => {
      const raceConfigUpdate = x.data.data.newRaceConfigUpdate;
      dispatch(updateCarRaceConfig(raceConfigUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeOffsetPreviewsUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_OFFSET_PREVIEWS_UPDATE, {
    onData: (x) => {
      const offsetPreviewsUpdate = x.data.data.newOffsetPreviewsUpdate;
      dispatch(updateCarOffsetPreviews(offsetPreviewsUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribePitPreviewsUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_PIT_PREVIEWS_UPDATE, {
    onData: (x) => {
      const pitPreviewsUpdate = x.data.data.newPitPreviewsUpdate;
      dispatch(updateCarPitPreviews(pitPreviewsUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeOptimisationTriggerUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_OPTIMISATION_TRIGGER_UPDATE, {
    onData: (x) => {
      const optimisationTriggerUpdate =
        x.data.data.newOptimisationTriggerUpdate;
      dispatch(updateCarOptimisationTrigger(optimisationTriggerUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}

export function SubscribeLapTableUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_LAP_TABLE_UPDATE, {
    onData: (x) => {
      const lapTableUpdate = x.data.data.newLapTableUpdate;
      dispatch(updateCarLapTable(lapTableUpdate));
    },
  });
  if (error) {
    console.log(error);
  }
}
